import OptionGroup from '../OptionGroup'
import StepShell, { Question, Hint } from '../StepShell'
import Field, { fieldInputClass } from '../Field'

const SPEND_BUCKETS = ['Under $10K', '$10K-$50K', '$50K-$150K', '$150K+']

export default function StepSpend({ answers, dispatch, active }) {
  return (
    <StepShell active={active} step={4}>
      <Question>What are you spending today?</Question>
      <Hint>Current monthly bill across OpenAI, Anthropic, and others.</Hint>
      <Field label="Monthly AI spend">
        <OptionGroup
          group="spend"
          options={SPEND_BUCKETS}
          value={answers.spend}
          onSelect={(group, value) => dispatch({ type: 'SET_ANSWER', field: group, value })}
        />
      </Field>
      <Field label="What's the workload? (optional)" htmlFor="reserve-workload">
        <textarea
          id="reserve-workload"
          name="workload"
          className={`${fieldInputClass} min-h-20 resize-y`}
          placeholder="e.g. coding agents, large-scale scraping, real-time document parsing"
          value={answers.use || ''}
          onChange={(e) => dispatch({ type: 'SET_ANSWER', field: 'use', value: e.target.value })}
        />
      </Field>
    </StepShell>
  )
}
